import React from 'react'
import Alert from '@mui/material/Alert';

function Alertt(props) {
  return <Alert  variant="filled" {...props} ></Alert>;
}

const Message = ({ variant, children }) => {
  return <Alertt severity={variant} >{children}</Alertt>

}

Message.defaultProps = {
  severity: 'info',
}

export default Message